import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper js-main-content" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter _flex" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-1of3--l gfu-4of6--l gfu-1of1 _mx-a" }
const _hoisted_4 = { class: "gfu-box _my-3" }
const _hoisted_5 = {
  class: "gfu-heading gfu-heading--soft gfu-box__title gfu-box__title--success",
  "data-qa": "account-submitted"
}
const _hoisted_6 = { class: "_tac" }
const _hoisted_7 = { class: "_mb-3 _pt-1" }
const _hoisted_8 = { class: "_mb-3" }
const _hoisted_9 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, " You are now a " + _toDisplayString(_ctx.platformName) + " creator! ", 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "_mb-3 _pt-1" }, " Your creator profile is ready to use. ", -1 /* CACHED */)),
            (_ctx.creatorUrlName)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_7, [
                    _createVNode(_component_base_button, {
                      tag: "a",
                      width: "wide",
                      href: _ctx.creatorProjectUrl,
                      "data-qa": "create-first-project"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" Create your first project ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href"])
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("p", { class: "_mb-3" }, "or", -1 /* CACHED */)),
                  _createElementVNode("p", _hoisted_8, [
                    _createElementVNode("a", {
                      class: "gfu-link gfu-link--accent",
                      href: _ctx.creatorSettingsUrl,
                      "data-qa": "go-to-creator-settings"
                    }, " go to your creator settings ", 8 /* PROPS */, _hoisted_9)
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}